document.addEventListener('DOMContentLoaded', () => {
  const items = document.querySelectorAll('[data-ugc-video]');

  items.forEach(item => {
    const video = item.querySelector('video');

    item.addEventListener('click', () => {
      items.forEach(other => {
        const otherVideo = other.querySelector('video');
        if (other !== item) {
          otherVideo.pause();
          otherVideo.currentTime = 0;
          other.classList.remove('playing');
        }
      });

      if (video.paused) {
        video.muted = false; // desbloquea audio
        video.play();
        item.classList.add('playing');
      } else {
        video.pause();
        item.classList.remove('playing');
      }
    });
  });
});
